/* eslint-disable react/jsx-pascal-case */
import { message, Button, Col, ConfigProvider, Form, Tag, Row, Select, Space, Table, Modal, Popconfirm, InputNumber } from "antd";
import dayjs from 'dayjs';
import React, { useContext, useEffect, useRef, lazy, Suspense, useState } from "react";
import { default as ProTableOT } from "../../utility/ProTable_ot";
import { useRoom } from "../controller/RoomController";
import RoomModal from "./RoomModal";
import axios from 'axios';
import { useNavigate } from "react-router-dom";
const { ConfigContext } = ConfigProvider
const setParamsFilter = (obj) => {
    //拿掉值為空或是null 的東西
    return Object.entries(obj).reduce((all, [key, value]) => value === "" ? { ...all } : { ...all, [key]: value }, {})
}
const Room = ({
    routePrefix='/audio_recorder/liveAdmin/'
}) => {
    const navigate = useNavigate()
    axios.interceptors.request.use(
        async (config) => {
            const access_token = localStorage.getItem("access_token");

            if (access_token) {
                config.headers = {
                    ...config.headers,
                    authorization: `Bearer ${access_token}`,
                };
            }
            return config;
        },
        (error) => Promise.reject(error)
    );
    axios.interceptors.response.use(
        response => {
            return response
        },
        function (error) {
            const access_token_url = '/access_token';
            const config = error.config
            if (
                error.response?.status === 401 &&
                config.url === access_token_url
            ) {
                window.location.href = ('/login')
                return Promise.reject(error)
            }

            if (error.response?.status === 401 && !config._retry) {
                config._retry = true
                const refreshToken = localStorage.getItem('refresh_token')
                if (!refreshToken) window.location.href = ('/login')
                return axios
                    .post(access_token_url, {
                        refresh_token: refreshToken
                    })
                    .then(res => {
                        if (res?.status === 201) {
                            localStorage.setItem('access_token', res.data.access_token);
                            config.headers = {
                                ...config.headers,
                                authorization: `Bearer ${localStorage.getItem('access_token')}`,
                            };
                            return axios(config)
                        }
                    })
            }
            return Promise.reject(error)
        }
    )
    const columns = [
        {
            title: '所屬選單名稱',
            dataIndex: 'permission_name',
            key: 'permission_name',
        },
        {
            title: '貼文名稱',
            dataIndex: 'blog_title',
            key: 'blog_title',
        },
        {
            title: '直播室名稱',
            dataIndex: 'name',
            key: 'name',
        },
        {
            title: '編號',
            dataIndex: 'code',
            key: 'code',
        },
        {
            title: '直播室連結',
            dataIndex: 'room_id',
            key: 'room_id',
            disabled: true,
            sorter: false,
            render: (text, record, index) => {
                return <Button
                    type="primary"
                    style={{
                        color: "#fff",
                        backgroundColor: "#A6A6A6"
                    }}
                    onClick={() => {
                        navigate(routePrefix+text)
                    }}
                >
                    點我前往
                </Button>
            }
        },
        {
            title: '操作',
            valueType: 'option',
            key: 'option',
            fixed: 'right',
            sorter: false,
            disabled: true,
            render: (text, record, _index) => {
                return (
                    <Space wrap>
                        <Button
                            type="link"
                            style={{
                                color: '#2BC17B'
                            }}
                            onClick={() => {
                                handleEditRow(record)
                            }}
                        >
                            修改
                        </Button>
                        <Popconfirm
                            title="刪除項目"
                            description="確定刪除勾選項目?"
                            onConfirm={() => handleDeleteRow(record?.room_id)}
                            onCancel={() => { }}
                        >
                            <Button
                                type="link"
                                danger>
                                刪除
                            </Button>
                        </Popconfirm>
                    </Space>
                )
            }
        },
    ];
    const [extra_columns, set_extra_columns] = useState([]);
    const actionRef = useRef();
    const [pageSize, setPageSize] = useState(20)
    const [selectedRowKeys, setSelectedRowKeys] = useState([])
    const [selectedRowsInfo, setSelectedRowsInfo] = useState([])
    const rowSelection = {
        //不一定都是對id
        onSelectAll: (selected, selectedRows, changeRows) => {
            let select_temp = [...selectedRowKeys]
            let selectRow = [...selectedRowsInfo]
            if (selected) {
                changeRows.map((value, key) => {
                    select_temp.push(value.room_id)
                    selectRow.push(value)
                })

            }
            else {
                changeRows.map((value, key) => {
                    const index = select_temp.indexOf(value.room_id);
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);

                })
            }
            setSelectedRowKeys(select_temp)
            setSelectedRowsInfo(selectRow)
        },
        onSelect: (record, selected, selectedRows, nativeEvent) => {
            let select_temp = [...selectedRowKeys]
            let selectRow = [...selectedRowsInfo]
            if (selected) {
                select_temp.push(record.room_id)
                selectRow.push(record)
            }
            else {
                select_temp = select_temp.filter(key => key !== record.room_id)
                selectRow = selectRow.filter(row => row.room_id !== record.room_id)
            }
            setSelectedRowKeys(pre => select_temp)
            setSelectedRowsInfo(selectRow)

        },
        getCheckboxProps: (record) => ({
            // disabled: record.pass === null,
        }),
    };
    const [modalOpen, setModalOpen] = useState(false)
    const [modalLoading, setModalLoading] = useState(false)

    const [form] = Form.useForm();

    const [axiosMode, setAxiosMode] = useState("get")
    const onCleanSelected = () => {
        setSelectedRowKeys([])
        setSelectedRowsInfo([])
    }
    const handleAddRow = () => {
        setAxiosMode("post")
        setModalOpen(true)
        form.resetFields()
    }
    const handleEditRow = (record) => {
        setAxiosMode("patch")
        setModalOpen(true)
        let news_time = dayjs(record?.news_time, "YYYY-MM-DD HH:mm:ss")
        let announce_time_end = record?.announce_time_end ? dayjs(record?.announce_time_end, "YYYY-MM-DD HH:mm:ss") : record?.announce_time_end


        form.resetFields()
        form.setFieldsValue({
            ...record,
            news_time,
            announce_time_end
        })
    }
    const handleDeleteRow = (id) => {
        let data = []
        if (id) {
            data = [{
                room_id: id
            }]
        }

        else {
            data = selectedRowsInfo.map((val) => {
                return {
                    room_id: val?.room_id
                }
            })
        }
        if (data.length > 0) {
            deleteRoomData(data)
        }
        else {
            message.info("請選擇項目")
        }
    }

    const onFormFinish = (values) => {
        if (axiosMode === "post") {
            postRoomData([values])
        }
        else if (axiosMode === "patch") {
            patchRoomData([values])
        }
    }
    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "post") {
                message.success("新增成功")
                actionRef.current.reloadAndRest();

            }
            else if (axiosMode === "patch") {
                message.success("修改成功")
                actionRef.current.reloadAndRest();

            }
            else if (axiosMode === "delete") {
                message.success("刪除成功")
                actionRef.current.reloadAndRest();
                setSelectedRowKeys([])
                setSelectedRowsInfo([])

            }
            setModalLoading(false)
            setModalOpen(false)
        }
        else if (status === "error") {
            if (axiosMode === "post") {
                message.error("新增失敗")
                actionRef.current.reloadAndRest();
            }
            else if (axiosMode === "patch") {
                message.error("修改失敗")
                actionRef.current.reloadAndRest();
            }
            else if (axiosMode === "delete") {
                message.error("刪除失敗")
                actionRef.current.reloadAndRest();
            }
            setModalLoading(false)
            setModalOpen(false)
        }
    }
    const onBefore = ({ axiosMode, status, values }) => {
        setModalLoading(true)
    }

    const {
        getRoomData,
        postRoomData,
        patchRoomData,
        deleteRoomData,
    } = useRoom({
        onFinish,
        onBefore,
    })
    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
    } = useTableColumnsCheck(columns)
    useEffect(() => {
        checkAll()
    }, [])

    return <Row>
        <Col>
            <RoomModal
                axiosMode={axiosMode}
                propsOpen={modalOpen}
                propsSetOpen={setModalOpen}

                propsForm={form}

                propsLoading={modalLoading}
                propsSetLoading={setModalLoading}

                onFinish={onFormFinish}
            />
        </Col>
        <Col span={24}>
            <ProTableOT
                actionRef={actionRef}
                headerTitle={<Space>
                    <Button
                        type='primary'
                        onClick={() => {
                            handleAddRow()
                        }}
                        style={{
                            backgroundColor: "#FFF9C9",
                            color: "#000"
                        }}
                    >
                        + 新增直播室
                    </Button>


                </Space>}
                columns={columns}
                check={check}
                setCheck={setCheck}
                rowKey={'room_id'}
                selections={{
                    // onChange: (index_, data_) => set_data(data_)
                }}
                toolBarRender={() => [
                    <Popconfirm
                        title="刪除直播室"
                        description="確定刪除勾選直播室?"
                        onConfirm={() => handleDeleteRow()}
                        onCancel={() => { }}
                    >
                        <Button
                            type='primary'
                            style={{
                                color: "#000",
                                backgroundColor: "#ffedee"
                            }}

                        >
                            刪除直播室
                        </Button>
                    </Popconfirm>
                ]}
                extra_columns={extra_columns}
                set_extra_columns={set_extra_columns}
                manage_columns={false}
                request={async (params = {}, sort, filter) => {
                    setAxiosMode("get")
                    let newParams = {
                    };
                    let order = setOrders(sort)
                    newParams = {
                        ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                        ...newParams,
                        order,
                        size: params.pageSize,
                        cur_page: params.current,
                        custom_filter_value: params.keyword ?? "",
                        custom_filter_key: custom_filter_key
                    };
                    newParams = setParamsFilter({
                        ...newParams,
                    });
                    setPageSize(params?.pageSize ?? 20)

                    return getRoomData(newParams)
                }}
                pageSize={pageSize}
                rowSelection={{
                    type: 'checkbox',
                    selectedRowKeys: selectedRowKeys,
                    ...rowSelection,
                }}
                tableAlertOptionRender={() => {
                    return (
                        <Space size={16}>
                            {/* <Typography.Link>匯出資料</Typography.Link> */}
                        </Space>
                    )
                }}
                tableAlertRender={({
                    selectedRowKeys,
                    selectedRows,
                    // onCleanSelected,
                }) => {
                    return (
                        <Space size={24}>
                            <span>
                                已選擇 {selectedRowKeys.length} 項
                                <a style={{ marginInlineStart: 8 }} onClick={onCleanSelected}>
                                    取消選擇
                                </a>
                            </span>
                        </Space>
                    );
                }}
                scroll={{
                    x: "max-content"
                }}

            />
        </Col>
    </Row>
}


const useTableColumnsCheck = (columns) => {
    const [check, setCheck] = useState([])
    const checkAll = () => {
        setCheck((pre) => {
            return columns
                .filter((element) => !element.disabled)
                .map((val) => val.key);
        });
    }
    const setOrders = (sorter) => {
        let newOrders = Object.keys(sorter).map((key, index) => {
            if (sorter[key] === "descend") {
                return JSON.stringify({
                    column: key,
                    type: 'DESC'
                })
            }
            else {
                return JSON.stringify({
                    column: key,
                    type: 'ASC'
                })
            }

        })
        return newOrders
    }
    return {
        check,
        custom_filter_key: check,
        setCheck,
        checkAll,
        setOrders
    }
}
export default Room;
